<template>
  <!-- <div class="product-list" :class="'terminal'+terminal"> -->
    <!-- <div class="picList">
      <ul class="clearfix" :class="'imgTextNum' +  componentContent.productNum">
        <li class="item" v-for="(item,index) in displayItems" :key="index">
          <div class="a-link" @click="gotoApp(item)">
            <div style="display: flex;align-items: center;">
              <el-image
                style="width: 24px;height: 24px; margin-right: 10px; min-width: 24px;"
                :src="item.iconImageUrl"
                fit="contain"></el-image>
              <div class="ell" :title="item.iconName">{{ item.iconName }}</div>
            </div>
          </div>
        </li>
      </ul> -->
      <!-- 展开/收起按钮 -->
      <!-- <div class="toggle-button-container" v-if="componentContent.productData.imgTextData && componentContent.productData.imgTextData.length > 24">
        <el-button class="toggle-button" type="text" @click="toggleExpand">
          <div class="flex gap_8">
            {{ isExpanded ? '点击收起' : '点击展开' }}<i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </el-button>
      </div>
    </div> -->
  <!-- </div> -->
  <div></div>
</template>

<script>
import {commonMixin} from '../mixin'
export default {
  mixins: [commonMixin],
  data () {
    return {
      swiperOption: {
        slidesPerView: 4, // 显示数量
        spaceBetween: 13, // 间隔
        autoplay: false, // 可选选项，自动滑动
        loop: true,
        pagination: {
          el: '.product-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      isExpanded: false // 控制展开状态
    }
  },
  computed: {
    // 计算属性，用于控制显示的项目
    displayItems () {
      const items = this.componentContent.productData.imgTextData
      if (!items) return []

      if (this.isExpanded || items.length <= 24) {
        return items
      } else {
        return items.slice(0, 24)
      }
    }
  },
  mounted () {
  },
  methods: {
    // 切换展开/收起状态
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list{
  padding: 16px;
  background-color: #fff;
  .picListWarp{
    width: 1380px;
    max-width: 100%;
    margin: 0 auto;
    position: relative;
  }
  .picList{
    margin: 0 auto;
    .swiper-button-prev,.swiper-button-next{
      width: 50px;
      height: 50px;
      position: absolute;
      cursor:pointer;
      top: 140px;
      background-repeat: no-repeat;
      &:after{
        content: '';
      }
    }
    .swiper-button-prev{
      left: 0;
      background: url('../../../static/images/btn-prev.png');
    }
    .swiper-button-next{
      right: 0;
      background: url('../../../static/images/btn-next.png');
    }
    .a-link{
      cursor: pointer;
      .itemImgBox {
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .imgBox {
          padding-bottom: 100%;
          background-color: #cacaca;
          position: relative;
          .el-image {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
      .text{
        padding: 10px;
        .h4{
          font-size: 16px;
          line-height: 24px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          box-orient: vertical;
          -webkit-box-orient: vertical;
          -o-box-orient: vertical;
          -ms-box-orient: vertical;
          -webkit-line-clamp: 2; // 显示两行
          line-clamp: 2;
          -webkit-line-clamp: 2;
          color: #333333;
          //max-height: 48px;
        }
        .p{
          color: #999;
          font-size: 16px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          padding-top: 18px;
          position: relative;
          margin-top: 8px;
          &:after{
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -80px;
            width: 160px;
            height: 2px;
            background: #F0F0F0;
            content: '';
          }
        }
        .priceBox {
          padding-top: 11px;
          line-height: 33px;
          span {
            font-size: 25px;
            color: #FF3B30;
            padding-right: 12px;
          }
          span.discount {
            font-size: 14px;
            color: rgba(22,26,30,0.4);
            // text-decoration: line-through;
          }
        }
      }
    }
    ul{
      display: flex;
      flex-wrap: wrap;
      gap: 11px;
      li{
        min-width: 120px;
        width: 120px;
      }
    }
    .imgTextNum2 {
      li {
        flex: 0 0 50%;
      }
    }
    .imgTextNum3 {
      li {
        flex: 0 0 33.33%;
      }
    }
    .imgTextNum4 {
      li {
        flex: 0 0 25%;
      }
    }
    .imgTextNum5 {
      li {
        flex: 0 0 20%;
      }
    }
  }
}

.toggle-button-container {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.toggle-button {
  cursor: pointer;
  font-size: 14px;
  color: #181818;
  padding: 0;
}

.btn-more {
  width: 130px;
  height: 41px;
  border: 2px solid #C5AA7B;
  color: #C5AA7B;
  font-size: 18px;
  background-color: transparent;
  margin: 20px auto 0;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/basics/applicationList/pc/index.vue